import React from 'react';
import Slider from 'react-slick';


class BannerSlider extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: this.props.data
        };
    }

    render() {
        var settings = {
            dots: false,
            arrows: false,
            autoplay: true,
            autoplaySpeed: 10000,
            pauseOnHover: true,
            infinite: true,
            draggable: false,
            swipe: false
        };
        return (
            <Slider {...settings}>
                {this.state.data}
            </Slider>
        );
    }
}
module.exports = BannerSlider;





// WEBPACK FOOTER //
// ./bannerslider.js